<p bitTypography="body1">
  {{ "troubleshootingDiagnosticReport" | i18n }}
  <a
    bitLink
    href="https://vowkey.com/contact/"
    target="_blank"
    rel="noopener noreferrer"
    endIcon="bwi-external-link"
  >
    {{ "vowkeySupport" | i18n }}
  </a>
</p>
<button bitButton type="button" buttonType="primary" (click)="download()">
  {{ "download" | i18n }}
</button>
